/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Gov_Starter_AuditInputs */



/**
* | output |
* | --- |
* | "7 days" |
*
* @param {Compare_Gov_Starter_AuditInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compare_gov_starter_audit = /** @type {((inputs?: Compare_Gov_Starter_AuditInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Gov_Starter_AuditInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("7 Tage")
	return /** @type {LocalizedString} */ ("7 days")
});